module.exports = __webpack_public_path__ + "media/flags/ge-4bc65ccf.svg";